import { Typography, TypographyProps } from "@mui/material"
import { ArticlesMeshResult } from "interface/article"

type MeshChipProps = {
  mesh: ArticlesMeshResult
} & TypographyProps
export const MeshChip = ({
  mesh,
  ...other
}: MeshChipProps) => {
  if (mesh.descriptionJpn) {
    return <Typography variant='body2' component='div' {...other}>{mesh.descriptionJpn}</Typography>
  } else {
    return <Typography variant='body2' component='div' translate='yes' {...other}>{mesh.description}</Typography>
  }
}
